import moment from "moment";

export const parseDeviceTime = value => {
  if (!value) return null;
  const parsed = moment(value, [moment.ISO_8601, "DD MMM YYYY HH:mm", "DD/MM/YYYY HH:mm:ss", "DD/MM/YYYY HH:mm", "YYYY-MM-DD HH:mm:ss"], true);
  return parsed.isValid() ? parsed : null;
};

export const formatDeviceTime = value => parseDeviceTime(value)?.format("DD MMM YYYY, HH:mm") || "—";

// Keep device metadata separate from report interval timestamps: a status
// change is not evidence of a communication or attendance punch.
export const mapMonitoringDevice = row => ({
  ...row,
  code: row.device_code ?? row.code ?? row.device_id ?? "—",
  type: row.device_type ?? row.type ?? "—",
  lastSeen: row.last_seen ?? row.lastSeen ?? null,
  lastPunch: row.last_punch ?? row.lastPunch ?? null,
  last_status_changed_local: row.status_from ?? null,
  duration: row.status_to ?? "—",
  duration_hours: row.elapsed_time ?? "—",
});

export const deviceHistoryEntries = (rows, deviceId, start, end) => {
  const entries = rows.filter(row => String(row.device_id) === String(deviceId)).flatMap(row => {
    const history = row.status_history ?? row.history;
    return Array.isArray(history) ? history : [{ at: row.last_status_changed_local, status: row.status, status_color: row.status_color }];
  });
  const unique = new Map();
  entries.forEach(entry => {
    // The API supplies local display dates/times alongside UTC date_time.
    const at = parseDeviceTime(entry.date && entry.time ? `${entry.date} ${entry.time}` : entry.date_time ?? entry.at ?? entry.last_status_changed_local ?? entry.time);
    if (!at || at.format("YYYY-MM-DD") < start || at.format("YYYY-MM-DD") > end) return;
    unique.set(entry.id ?? `${at.valueOf()}-${entry.status}`, { ...entry, at: at.toISOString() });
  });
  return [...unique.values()].sort((a, b) => b.at.localeCompare(a.at));
};

export const monitoringDeviceStatusUrl = (domain, { deviceId, startDate, endDate, afterId, historyOffset } = {}) => {
  const params = new URLSearchParams();
  if (deviceId != null) params.set("deviceId", deviceId);
  if (startDate) params.set("start_date", startDate);
  if (endDate) params.set("end_date", endDate);
  if (afterId != null) params.set("after_id", afterId);
  if (historyOffset != null) params.set("history_offset", historyOffset);
  const query = params.toString();
  return `${domain}monitoring/device-status/${query ? `?${query}` : ""}`;
};
